import { CoreModule, ListService } from '@abp/ng.core';
import { ChangeDetectionStrategy, Component } from '@angular/core';

import { PaymentHistoryComponent } from './payment-history/payment-history-component';
import { PaymentHistoryViewService } from 'src/app/payments/services/payment-history.service';

/**
 * The profile's Payment tab. Saved cards used to live here alongside payment history; they were
 * removed with the move to EdfaPay's hosted page, which collects the card on its own site every
 * time and never gave us anything chargeable to store. Only the history remains.
 */
@Component({
    selector: 'app-payment-tab',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './payment-tab.component.html',
    styleUrls: ['./payment-tab.component.scss'],
    imports: [CoreModule, PaymentHistoryComponent],
    providers: [ListService, PaymentHistoryViewService]
})
export class PaymentTabComponent {}
